import { render, staticRenderFns } from "./EnacAtplDashboardItemLearnerResult.vue?vue&type=template&id=72873ba8"
import script from "./EnacAtplDashboardItemLearnerResult.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardItemLearnerResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports